import { render, staticRenderFns } from "./OzLargeConfirmationDialog.vue?vue&type=template&id=74d31926&"
import script from "./OzLargeConfirmationDialog.vue?vue&type=script&setup=true&lang=ts&"
export * from "./OzLargeConfirmationDialog.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports